import { useRouteError } from 'react-router'
import { ApiRequestError } from '../api.ts'
import { NotFoundPage } from '../components/error-pages/not-found-page.tsx'
import InShellErrorBoundary from './in-shell-error-boundary.tsx'

// RAL-18: route-scoped boundary for /assets/:id and /review/:assetId/:id, whose loaders 404
// when the item belongs to an account other than the one currently active (e.g. switching the
// active TikTok account mid-view). The backend collapses that case into a generic "not found"
// (no distinguishing code — see backend/routes/api/assets.ts), so we render the same honest
// "nothing at this address" 404 the unmatched-route catch-all uses in router.tsx rather than
// guess a specific reason (RAL-163's no-guessing rule) or claim a Rally-side failure. Any other
// thrown error (5xx, network) still falls through to the generic in-shell boundary.
export default function ItemNotFoundErrorBoundary() {
  const error = useRouteError()
  if (error instanceof ApiRequestError && error.status === 404) {
    return <NotFoundPage reason="never_existed" />
  }
  return <InShellErrorBoundary />
}
